// ドロワーメニュー
const navTrigger = document.querySelector('.nav-trigger');
const body = document.body;

if (navTrigger) {
	let scrollPosition = 0;

	const openNav = () => {
		scrollPosition = window.scrollY || document.documentElement.scrollTop;
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		body.classList.add('nav-open');
		body.style.cssText = `position:fixed;width:100%;height:100%;top:-${scrollPosition}px;padding-right:${scrollbarWidth}px`;
	};

	const closeNav = () => {
		body.classList.remove('nav-open');
		body.removeAttribute('style');
		window.scrollTo(0, scrollPosition);
	};

	navTrigger.addEventListener('click', (e) => {
		e.preventDefault();
		body.classList.contains('nav-open') ? closeNav() : openNav();
	});

	// ドロワー内のリンクのみ（.lineupのアンカーは除外）
	document.querySelectorAll('.nav-container nav a').forEach((el) => {
		el.addEventListener('click', closeNav);
	});

	// 画面回転: アニメーションを切ってから初期状態に戻す
	window.addEventListener('orientationchange', () => {
		body.classList.add('is-resizing');
		body.removeAttribute('style');
		body.classList.remove('nav-open');
		setTimeout(() => body.classList.remove('is-resizing'), 300);
	});
}
